import type { FC } from 'react';

import classNames from 'classnames';

import Icon, { ICONS } from '../../icons/icon';

import styles from './help_link.module.css';

type Props = {
  path: string;
  text: string;
  withIcon?: boolean;
  inverted?: boolean;
};

const HelpLink: FC<Props> = ({ path, text, withIcon = false, inverted }) => {
  if (withIcon) {
    return (
      <a
        href={path}
        target="_blank"
        className={classNames(styles.link_with_icon, {
          [styles.inverted]: inverted,
        })}
        rel="noopener noreferrer"
      >
        <Icon icon={ICONS.Help} />
        {text}
      </a>
    );
  }

  return (
    <a
      href={path}
      target="_blank"
      className={classNames(styles.link, { [styles.inverted]: inverted })}
      rel="noopener noreferrer"
    >
      {text}
    </a>
  );
};

export default HelpLink;
